import Vue from "vue";
export default Vue.extend({
  data() {
    return {
      status: ""
    };
  },
  watch: {
    status() {
      this.$router
        .replace({
          query: {
            ...this.$route.query,
            status: this.status
          }
        })
        .catch(e => {
          e;
        });
    }
  },
  methods: {
    getStatusRouteQuery() {
      const { status } = this.$route.query;
      this.status = status ? status.toString() : "";
    },
    setStatusQuery(status: string) {
      this.status = status;
    }
  }
});
